// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"0299f199","441":"6da23f47","706":"fdc220e4","863":"16f756a0","989":"a6e6a9aa"}[chunkId] + ".chunk.js";
};